import React, { useEffect, useState } from "react";
import API from "../../services/api";
import { Button } from "primereact/button";

export default function LeadModal({
  modalRef,
  form,
  editId,
  onChange,
  onSubmit,
  submitLoading,
  onCancelEdit,
  validated,
  errors,
  setValidated,
  setErrors,
}) {
  const [positions, setPosition] = useState([]);

  useEffect(() => {
    const fetchMaster = async () => {
      try {
        const positionRes = await API.get("/position");
        setPosition(positionRes.data);
      } catch (err) {
        console.error("Gagal load master:", err);
      }
    };
    fetchMaster();
  }, []);

  return (
    <form
      noValidate
      className={validated ? "was-validated" : ""}
      onSubmit={onSubmit}
    >
      <div
        className="modal fade"
        id="leadModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modalLabel"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-lead">
          <div className="modal-content shadow-sm border-0 rounded-4">
            {/* ================= HEADER ================= */}
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title fw-semibold" id="modalLabel">
                {editId ? "Edit Lead" : "Tambah Lead"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            {/* ================= BODY ================= */}
            <div className="modal-body pt-3">
              <div className="row g-3">
                {/* Nama */}
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={onChange}
                      className={`form-control ${
                        errors.name ? "is-invalid" : ""
                      }`}
                      placeholder="Nama"
                      required
                    />
                    <label>Nama</label>
                    <div className="invalid-feedback">
                      {errors.name || "Nama wajib diisi."}
                    </div>
                  </div>
                </div>

                {/* Nomor Telepon */}
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      name="phone_number"
                      value={form.phone_number}
                      onChange={onChange}
                      className={`form-control ${
                        errors.phone_number ? "is-invalid" : ""
                      }`}
                      placeholder="Nomor Telepon"
                      required
                    />
                    <label>Nomor Telepon</label>
                    <div className="invalid-feedback">
                      {errors.phone_number || "Nomor Telepon wajib diisi."}
                    </div>
                  </div>
                </div>

                {/* KLPD */}
                <div className="col-md-6">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      name="klpd"
                      value={form.klpd || ""}
                      onChange={onChange}
                      required
                    >
                      <option value="">-- Pilih KLPD --</option>
                      <option value="Kementerian">Kementerian</option>
                      <option value="Lembaga">Lembaga</option>
                      <option value="Pemerintah Daerah">
                        Pemerintah Daerah
                      </option>
                      <option value="Belum diketahui">Belum diketahui</option>
                    </select>
                    <label>KLPD</label>
                    <div className="invalid-feedback">KLPD wajib diisi.</div>
                  </div>
                </div>

                {/* Jabatan */}
                <div className="col-md-6">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      name="position_id"
                      value={form.position_id || ""}
                      onChange={onChange}
                      required
                    >
                      <option value="">-- Pilih Jabatan --</option>
                      {positions.map((position) => (
                        <option key={position.id} value={String(position.id)}>
                          {position.initials}
                        </option>
                      ))}
                    </select>
                    <label>Jabatan</label>
                    <div className="invalid-feedback">Jabatan wajib diisi.</div>
                  </div>
                </div>

                {/* Instansi / Satker */}
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      name="institution_or_business"
                      value={form.institution_or_business}
                      onChange={onChange}
                      className="form-control"
                      placeholder="Instansi / Satker"
                      required
                    />
                    <label>Instansi / Satker</label>
                    <div className="invalid-feedback">
                      Instansi / Satker wajib diisi.
                    </div>
                  </div>
                </div>

                {/* Lokasi */}
                <div className="col-md-6">
                  <div className="form-floating">
                    <textarea
                      name="location"
                      value={form.location}
                      onChange={onChange}
                      className="form-control"
                      placeholder="Lokasi"
                      required
                      style={{ height: "120px" }}
                    />
                    <label>Lokasi</label>
                    <div className="invalid-feedback">Lokasi wajib diisi.</div>
                  </div>
                </div>
              </div>
            </div>

            {/* ================= FOOTER ================= */}
            <div className="modal-footer border-top pt-3">
              <Button
                label="Close"
                icon="pi pi-times"
                outlined
                severity="secondary"
                type="button"
                className="rounded px-4"
                data-bs-dismiss="modal"
                onClick={() => {
                  setValidated(false);
                  setErrors({});
                }}
              />
              <Button
                label={
                  submitLoading ? "Memproses..." : editId ? "Update" : "Tambah"
                }
                icon={editId ? "pi pi-save" : "pi pi-plus"}
                severity="primary"
                loading={submitLoading}
                type="submit"
                className="rounded px-4"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
